import { render, staticRenderFns } from "./EditOrganizationTests.vue?vue&type=template&id=076c0660&scoped=true"
import script from "./EditOrganizationTests.vue?vue&type=script&lang=js"
export * from "./EditOrganizationTests.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationTests.vue?vue&type=style&index=0&id=076c0660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076c0660",
  null
  
)

export default component.exports